import { OpenNewTabTargetType } from '@voltmoney/types';
import { rebuildReferredPartnerMobileCardBuilder, rebuildReferredPartnerTable, searchObject, sideBarNavigate, sortReferredPartnerObjectByProperty, } from '../partnerWeb_Dashboard/utils';
import SharedPropsService from '../../SharedPropsService';
import { onShareAdvisory, openAdvisorLinkWhatsApp, openAdvisorLinkWhatsAppOnPhone, openAdvisoryLinkTelegram, } from '../../configs/utils';
import { InviteAndEarnLink } from '../../configs/constants';
import { ROUTE } from '../../routes';
let ReferredPartnerDataOriginal = [];
let tableSearchString_RP = '';
let ReferredPartnerData = [];
let ascOrder = true;
export const onSearchReferredPartner = async (action, _datastore, standardUtilities) => {
    console.warn('**** PartnerSearch Action Triggered ****', action);
    tableSearchString_RP = action.payload.value;
    ReferredPartnerData = ReferredPartnerDataOriginal.filter(data => {
        const results = searchObject(data, tableSearchString_RP);
        if (results && results.length > 0) {
            return true;
        }
        else {
            return false;
        }
    });
    if (action?.payload?.widgetId === 'referredPartnerMobSearchInput') {
        await rebuildReferredPartnerMobileCardBuilder(standardUtilities, ReferredPartnerData);
    }
    else {
        await rebuildReferredPartnerTable(standardUtilities, ReferredPartnerData, action);
    }
};
export const onSortReferredPartner = async (action, _datastore, standardUtilities) => {
    console.warn('**** Sort leads Action Triggered ****', action);
    ReferredPartnerData = sortReferredPartnerObjectByProperty(ReferredPartnerData, action.payload.value, ascOrder);
    ascOrder = !ascOrder;
    await rebuildReferredPartnerTable(standardUtilities, ReferredPartnerData, action);
};
export const onLoadReferredPartner = async (action, _datastore, { navigate, goBack, setDatastore }) => {
    console.warn('**** Test Action Triggered ****', action);
    ReferredPartnerData = await SharedPropsService.getReferredPartnerData();
    ReferredPartnerDataOriginal =
        await SharedPropsService.getReferredPartnerData();
};
export const onChangeTab = async (action, _datastore, standardUtilities) => {
    await sideBarNavigate(standardUtilities, action);
};
export const onCtaWhatsApp = async (action, _datastore, { instrumentTrack }) => {
    instrumentTrack("REFER_MFD_INITIATED", {
        "type": "WhatsApp"
    });
    console.warn('**** onCtaWhatsApp leads Action Triggered ****', action);
    const advisoryLink = action.payload.advisorLink;
    const partnerName = action.payload.partnerName;
    const partnerInterestRate = action?.payload?.partnerInterestRate;
    if (action.payload.value === 'WEB') {
        openAdvisorLinkWhatsApp(partnerInterestRate, advisoryLink, partnerName);
    }
    else {
        openAdvisorLinkWhatsAppOnPhone(partnerInterestRate, advisoryLink, partnerName);
    }
};
export const onCtaTelegram = async (action, _datastore, { instrumentTrack }) => {
    instrumentTrack("REFER_MFD_INITIATED", {
        "type": "Telegram"
    });
    console.warn('**** onCtaTelegram leads Action Triggered ****', action);
    const advisoryLink = action.payload.advisorLink;
    const partnerName = action.payload.partnerName;
    const partnerInterestRate = await SharedPropsService.getFirebaseConfig()?.partner_interest_rate;
    openAdvisoryLinkTelegram(`${partnerInterestRate}`, advisoryLink, partnerName);
};
export const onCtaCopyLink = async (action, _datastore, { clipboard, setDatastore, instrumentTrack }) => {
    instrumentTrack("REFER_MFD_INITIATED", {
        "type": "copy_link"
    });
    console.warn('**** onCtaCopyLink leads Action Triggered ****', action);
    const advisoryLink = action.payload.advisorLink;
    // const partnerName = action.payload.partnerName;
    await setDatastore(ROUTE.PARTNER_REFERRED_PARTNER, 'referMfdAndAdvisorsB3', { label: 'Link Copied' });
    clipboard.set(advisoryLink);
    setTimeout(async () => {
        await setDatastore(ROUTE.PARTNER_REFERRED_PARTNER, 'referMfdAndAdvisorsB3', { label: 'Copy Link' });
    }, 1000);
};
export const onCtaShareLink = async (action, _datastore, standardUtilities) => {
    console.warn('**** onCtaShareLink leads Action Triggered ****', action);
    const advisoryLink = action.payload.advisorLink;
    const partnerName = action.payload.partnerName;
    const partnerInterestRate = await SharedPropsService.getFirebaseConfig()?.partner_interest_rate;
    onShareAdvisory(`${partnerInterestRate}`, advisoryLink, partnerName);
};
export const onKnowMore = async (action, _datastore, { openNewTab, instrumentTrack }) => {
    instrumentTrack("INVITE_PARTNER_BANNER_CTA_CLICKED", {
        "page": "referred_partner"
    });
    console.warn('**** onKnowMore leads Action Triggered ****', action);
    openNewTab(`${InviteAndEarnLink}`, OpenNewTabTargetType.blank);
};
export const onFaq = async (action, _datastore, { openNewTab }) => {
    console.warn('**** onKnowMore leads Action Triggered ****', action);
    openNewTab('https://voltmoney.in/invite-mfd-terms-and-condition', OpenNewTabTargetType.blank);
};
